<template>
  <div class="pdf-viewport-tools">
    <b-button
      size="sm"
      variant="primary"
      type="submit"
      :disabled="value === 1"
      @click="$emit('input', 1)"
    >
      <feather-icon
        v-b-tooltip.hover.left="'Primera página'"
        icon="ChevronsLeftIcon" />
    </b-button>
    <b-button
      size="sm"
      variant="primary"
      type="submit"
      :disabled="value === 1"
      @click="$emit('input', value != -1 ? value - 1: pages - 1)"
    >
      <feather-icon
        v-b-tooltip.hover.left="'Página anterior'"
        icon="ChevronLeftIcon" />
    </b-button>
    <PdfPageSelector
      :value="value"
      :pages="pages"
      @input="$emit('input', $event)"
      small
    />
    <b-button
      size="sm"
      variant="primary"
      type="submit"
      :disabled="value === pages || value === -1"
      @click="$emit('input', value + 1)"
    >
      <feather-icon
        v-b-tooltip.hover.left="'Página siguiente'"
        icon="ChevronRightIcon" />
    </b-button>
    <b-button
      size="sm"
      variant="primary"
      type="submit"
      :disabled="value === pages || value === -1"
      @click="$emit('input', pages)"
    >
      <feather-icon
        v-b-tooltip.hover.left="'Última página'"
        icon="ChevronsRightIcon" />
    </b-button>
  </div>
</template>

<script>

import PdfPageSelector from '@/febos/global/pdf/components/PdfPageSelector';

export default {
  components: {
    PdfPageSelector
  },
  props: {
    value: { type: Number, required: true },
    pages: { type: Number, required: true }
  },
};

</script>

<style lang="scss" scoped>

@import '~@core/scss/base/bootstrap-extended/_include';

.pdf-viewport-tools {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
}

.pdf-viewport-tools *:not(:last-child) {
  margin-right: $spacer * .5;
}

</style>
